<template>
  <gd-modal
    name="create-category-modal"
    :title="$t('frontend_grooveblog_add_new_category')"
    @closed="reset"
  >
    <div class="flex flex-col px-8 py-5">
      <div class="flex flex-col w-full mb-4">
        <label class="text-grey-dark mb-2">{{ $t('frontend_name') }}</label>
        <text-input
          class=""
          v-model="categoryPost.name"
          :validator="$v.categoryPost.name"
          :attribute="$t('frontend_name')"
          placeholder=""
        />
      </div>
      <div class="flex flex-col w-full mb-4">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_category_slug') }}</label>
        <text-input
          class=""
          v-model="categoryPost.slug"
          :validator="$v.categoryPost.slug"
          :attribute="$t('frontend_grooveblog_category_slug')"
          placeholder=""
        />
        <div class="text-grey-500 mt-1">
          {{ $t('frontend_yourblogname_slash_categoryname') }}
        </div>
      </div>
      <div class="flex flex-col w-full mb-4">
        <label class="text-grey-dark mb-2">{{ $t('frontend_desc') }}</label>
        <text-area
          v-model="categoryPost.description"
          :validator="$v.categoryPost.description"
          :attribute="$t('frontend_desc')"
          class="w-full modal-textarea"
          placeholder=""
          @keyup="usedCount = categoryPost.description.length"
        />
        <div class="text-grey-500 mt-1">
          {{ $t('frontend_grooveblog_max_500_char') }} {{ usedCount }}
        </div>
      </div>
      <div class="flex flex-row items-center w-full mb-4">
        <label class="text-grey-dark mr-4">{{
          $t('frontend_grooveblog_show_in_navigation')
        }}</label>
        <gd-toggle dark v-model="visibleNav" />
      </div>
      <div class="flex flex-row w-full mt-4 justify-center">
        <gd-button
          class="text-center h-10 border-grey-1"
          size="large"
          @click="close"
          >{{ $t('frontend_cancel') }}</gd-button
        >
        <gd-button
          class="text-center h-10 ml-4"
          size="large"
          variant="primary"
          @click="submitData"
          >{{ $t('frontend_done') }}</gd-button
        >
      </div>
    </div>
  </gd-modal>
</template>

<script>
import axios from 'axios';
import {
  required,
  maxLength,
} from 'vuelidate/lib/validators';

export default {
  props: {
    blogId: {
      required,
    }
  },
  data() {
    return {
      categoryPost: {
        blog_id: '',
        name: '',
        slug: '',
        description: '',
        visible: '',
      },
      visibleNav: false,
      usedCount: 0,
    };
  },
  validations: {
    categoryPost: {
      name: {
        required,
      },
      slug: {
        required,
      },
      description: {
        required,
        maxLength: maxLength(500),
      },
    },
  },
  methods: {
    open() {
      this.$root.$emit('modal-open', 'create-category-modal');
    },
    close() {
      this.$root.$emit('modal-close', 'create-category-modal');
      this.reset();
    },
    reset() {
      this.$v.$reset();
      this.categoryPost = {
        blog_id: '',
        name: '',
        slug: '',
        description: '',
        visible: '',
      };
      this.visibleNav = false;
      this.usedCount = 0;
    },
    async submitData() {
      this.$v.categoryPost.$touch();
      if (!this.$v.categoryPost.$invalid) {
        this.$v.categoryPost.$reset();
        this.$emit('setIsLoading', true);
        this.categoryPost.blog_id = this.blogId;
        this.categoryPost.slug = this.categoryPost.slug
          .replace(/[^A-Z0-9]+/gi, '-')
          .replace(/^-+/, '') // trim - from start of text
          .replace(/-+$/, '') // trim - from end of text
          .toLowerCase();
        this.categoryPost.visible = this.visibleNav;
        await axios
          .post('/categories', this.categoryPost)
          .then(() => {
            this.$emit('getCategory',this.blogId);
          })
          .catch((error) => {
            console.log(error);
          });
        this.$emit('setIsLoading', false);
        this.close();
      }
    },
  },
};
</script>
